// extracted by mini-css-extract-plugin
export default {"container":"faq_container__oP31E","title":"faq_title__w8zCs","box":"faq_box__Ae9fe","question":"faq_question__a91im","answer":"faq_answer__DsX+Q","aligned":"faq_aligned__adq9S"};